// Keep in parity with: sb1/db/tables/scriptbooks.py
enum DraftStatus {
  RUNNING = "running",
  REPLACED = "replaced",
  PROOFING = "proofing",
  ARCHIVED = "archived",
  DRAFT = "draft",
}

export default DraftStatus;
